import React from 'react';
import PropTypes from 'prop-types';
import './success-alert-message.scss';
import { Checkmark16 } from '@carbon/icons-react';
import { t } from 'components/translation/Translation';

const SuccessAlertMessage = () => {
  return (
    <div className="success-alert-message" data-testid="passwordResetSuccess">
      <Checkmark16 />
      <p className="success-alert-message__text" data-testid="passwordResetSuccessMessage">
        {t('parent:password_reset.success')}
      </p>
    </div>
  );
};

SuccessAlertMessage.propTypes = {};

export default SuccessAlertMessage;
